import { render, staticRenderFns } from "./DealingsBalanceView2MultiCurrency.vue?vue&type=template&id=7f08560b&scoped=true&"
import script from "./DealingsBalanceView2MultiCurrency.vue?vue&type=script&lang=js&"
export * from "./DealingsBalanceView2MultiCurrency.vue?vue&type=script&lang=js&"
import style0 from "./DealingsBalanceView2MultiCurrency.vue?vue&type=style&index=0&id=7f08560b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f08560b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f08560b')) {
      api.createRecord('7f08560b', component.options)
    } else {
      api.reload('7f08560b', component.options)
    }
    module.hot.accept("./DealingsBalanceView2MultiCurrency.vue?vue&type=template&id=7f08560b&scoped=true&", function () {
      api.rerender('7f08560b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FinanceManage/AccountBook/DealingsBalanceView2MultiCurrency.vue"
export default component.exports